import React from 'react';
import { Message, Assistant } from '@/types';
import { MessageBubble, StreamingMessage, LoadingIndicator } from './';  // ← Updated!
import { AdBanner } from '../ads/AdBanner';
import { AdData } from '@/types';

interface ChatContainerProps {
    messages: Message[];
    assistant: Assistant;
    isLoading: boolean;
    streamingMessage: string;
    milestoneAd: AdData | null;
    currentTool?: string | null;
}

export const ChatContainer: React.FC<ChatContainerProps> = ({
                                                                messages,
                                                                assistant,
                                                                isLoading,
                                                                streamingMessage,
                                                                milestoneAd,
                                                                currentTool
                                                            }) => {
    return (
        <>
            {messages.map(message => (
                <MessageBubble
                    key={message.id}
                    message={message}
                    assistant={assistant}
                />
            ))}

            {isLoading && !streamingMessage && (
                <LoadingIndicator assistant={assistant} currentTool={currentTool} />
            )}

            {streamingMessage && (
                <StreamingMessage content={streamingMessage} assistant={assistant} />
            )}

            {/*{milestoneAd && <AdBanner ad={milestoneAd} />}*/}
        </>
    );
};